import * as React from 'react';
import Select, { components } from 'react-select';

class CheckboxMultiSelectPipeOption extends React.Component<any, any> {
    static defaultProps = {
        options: []
    };

    render() {
        const {
            options,
            onChangeCallback,
            value,
            disabled,
            ...otherProps
        } = this.props;
        const updateLabel = this.props.updateLabel
            ? this.props.updateLabel
            : 'pipingQuestions';
        return (
            <Select
                value={value}
                className={'react-select react-select--multielement'}
                classNamePrefix="react-select"
                closeMenuOnSelect={false}
                isMulti
                // components={{ Option, MultiValue, IndicatorsContainer }}
                options={options}
                hideSelectedOptions={false}
                backspaceRemovesValue={false}
                onChange={(values) => onChangeCallback(updateLabel, values)}
                {...otherProps}
                isMenuOpen={true}
                isDisabled={disabled}
            />
        );
    }
}

export const SingleValue = (props) => (
    <components.SingleValue {...props}>
        <span>
            {props.data.label || props.data.title} {props.data.greetingText}
        </span>
    </components.SingleValue>
);

export default CheckboxMultiSelectPipeOption;
